<template>
    <div id="eval_new_step1" class="flex">
    
        <titlePage>
            <template slot="titleBody">
                <h1 class="title is-size-1 has-text-weight-bold stepTitle page-title">
                    {{ $t('modules.evaluations.formStep1.title') }}
                </h1>
            </template>
        </titlePage>
    
    
        <div class="hero flex subsection_container">
    
            <div class="hero-body flex_content">
                <div class="container  micro-container has-text-centered">
    
                <h2 class="title is-size-1 has-text-weight-light stepTitle">
                    {{ $t('modules.evaluations.formStep1.formTitle') }}
                </h2>
    
    
                <div class="form_material_container">
    
                    <InputMaterialWrap
                        v-model="currentEval.candidate_first_name"
                        :label="$t('modules.evaluations.formStep1.inputLabel1')"
                        validate='required'
                        input-id="evalFirstName"
                        @input="updateFormData">
                    </InputMaterialWrap>
    
                    <InputMaterialWrap
                        v-model="currentEval.candidate_last_name"
                        :label="$t('modules.evaluations.formStep1.inputLabel2')"
                        validate='required'
                        input-id="evalLastName"
                        @input="updateFormData">
                    </InputMaterialWrap>
    
                    <InputMaterialWrap
                        v-model="currentEval.candidate_email"
                        :label="$t('modules.evaluations.formStep1.inputLabel3')"
                        validate='required|email'
                        input-id="evalEmail"
                        @input="updateFormData">
                    </InputMaterialWrap>
    
                    <btn-circle-icon
                        :class="{disabled: !isFormValid}"
                        class="large is-cursor"
                        icon="icon-arrow-right"
                        @click.native="nextStep" />
                </div>
    
                </div>
            </div>
        </div>
    </div>
    
    
    </template>
    
    <script>
    import TitlePage from "@/components/layouts/titlePage"
    
    export default {
        name: 'FormEvalStep1',
        components: {
            TitlePage
        },
        data(){
            return {}
        },
        computed: {
            currentEval(){
                return this.$store.state.EvalStore.currentEval
            },
            isFormValid(){
                if (this.fields.evalEmail && this.fields.evalFirstName && this.fields.evalLastName){
                    return (this.fields.evalEmail.valid && this.fields.evalFirstName.valid && this.fields.evalLastName.valid)
                }else{
                    return false
                }
            },
        },
        methods: {
            nextStep(){
                this.$validator.validateAll()
                if(this.isFormValid){
                    this.$store.commit('EvalStore/changeCurrentStep', { index: 1 })
                }
            },
            updateFormData(formData){
                this.$store.commit('EvalStore/updateFormValidity', { index: 0, validity: this.isFormValid } )
                this.$store.commit('EvalStore/updateEvalData', this.currentEval )
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    #eval_new_step1{
        background: $white;
        display: flex;
        flex-direction: column;
        .subsection_container{
            .hero-body{
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    </style>